export default __webpack_public_path__ + "static/media/DCA_556x323.7d911fde.jpg";